import React from 'react';
import { COMPANY } from '../data/siteData';
import { useFormModal } from '../context/FormModalContext';

const ContactsPage = () => {
    const { openForm } = useFormModal();

    return (
        <div className="page">
            <div className="container page-container">
                <h1 className="page-title">Контакты</h1>

                <div className="page-content">
                    <div className="contact-card">
                        <dl className="contact-list">
                            <div className="contact-item">
                                <dt>Адрес</dt>
                                <dd>{COMPANY.address}</dd>
                            </div>
                            <div className="contact-item">
                                <dt>E-mail</dt>
                                <dd>
                                    <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
                                </dd>
                            </div>
                            <div className="contact-item">
                                <dt>Режим работы</dt>
                                <dd>{COMPANY.workHours}</dd>
                            </div>
                        </dl>
                    </div>

                    <p>
                        По вопросам вакансий, условий работы и обработки персональных данных обращайтесь по
                        указанным контактам. Заявку также можно оставить через форму на сайте.
                    </p>

                    <button type="button" className="cta-button" onClick={openForm}>
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContactsPage;
